import { Stack } from "@mui/material";
import React, { useEffect } from "react";
import Section1 from "./Section1";
import Section2 from "./Section2";
import CustomCard from "./CustomCard";
import CardGrid from "./CardGrid";
import Header from "../../Header/Header";
import Footer from "../../Footer/Footer";
import Section4 from "./Section4";
import CertificateCard from "../CertificateCard/CertificateCard";

const IndustrieSection = () => {
  // Scroll to top when the component is mounted
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return (
    <>
      <Header />
      <main>
        <Stack>
          <Stack>
            <Section1 />
            <Section2 />
            <CardGrid />
            <Section4 />
          </Stack>
        </Stack>
      </main>
      <CertificateCard />
      <Footer />
    </>
  );
};

export default IndustrieSection;
